export const createSpaceOrRegex = (search) => {

  let working = String(search);

  // escape regex special chars
  working = working.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // Default the token with full string match
  let tokens = [working];

  // If string contains "
  if (working.search("\"") !== -1) {
    // Create array of phrases between quotation marks
    const phrases =
      working.replace(/^[^"]*"/, '')// trim everything before first quotation
        .replace(/"[^"]*$/, '') 		// trim everything after last quotation
        .split(/"[^"]*"/);      	 	// split between quotations

    // Add phrases to tokens array
    tokens = tokens.concat(phrases);

    // Remove phrases from working string so not duplicated
    working = working.replace(/"[^"]*"/gi, '');

    // remove any remaining "
    working = working.replace(/"/g, '');
  }

  // Split working string into array of remaining words and add to tokens
  tokens = tokens.concat(working.split(/\s+/));

  // Strip out empty tokens
  tokens = tokens.filter(function (n) {
    return n !== undefined && n !== ''
  });

  // Create piped regex string from tokens
  let regexText = '';
  for (let i = 0; i < tokens.length; i++) {

    if (i > 0) regexText += '|';

    regexText += tokens[i];
  }

  // Set output to narrativeRexExp
  return new RegExp('(' + regexText + ')', 'gi');
};


// WEBPACK FOOTER //
// ./src/utils/search-utils.js